import React from 'react';
import { AISummary } from './AISummary';
import { useAnalyzeSummarize } from './useAnalyzeSummarize';
import { logger } from '@src/utils/misc/logger';

interface DPISummaryProps {
  interval?: string;
  viewerId?: string[];
  clientId?: string;
  sessionId?: string;
  summaryData?: any;
  timelineData?: any;
}

/**
 * DPISummary - Container component for DPI (Digital Performance Insights) AI Summary
 * Receives already-fetched timeline and summary data as props
 */
export default function DPISummary({
  interval,
  viewerId = [],
  clientId,
  sessionId,
  summaryData,
  timelineData,
}: DPISummaryProps) {
  const { isLoading, data, error, summarize } = useAnalyzeSummarize();

  const handleGenerate = async () => {
    // Log the data availability
    logger.log('DPISummary - Data from props:', {
      summaryAvailable: !!summaryData,
      timelineAvailable: !!timelineData,
      summaryDataKeys: summaryData ? Object.keys(summaryData) : [],
      timelineDataKeys: timelineData ? Object.keys(timelineData) : [],
    });

    const diagnosticPayload = {
      type: 'user-timeline-summary',
      summaryData,
      timelineData,
      interval,
      viewerId,
      clientId,
      sessionId,
    };

    logger.log('DPISummary - Payload ready', {
      type: diagnosticPayload.type,
      hasSummaryData: !!diagnosticPayload.summaryData,
      hasTimelineData: !!diagnosticPayload.timelineData,
    });

    await summarize(diagnosticPayload);
  };

  const handleRegenerate = async () => {
    const diagnosticPayload = {
      type: 'user-timeline-summary',
      summaryData,
      timelineData,
      interval,
      viewerId,
      clientId,
      sessionId,
    };

    await summarize(diagnosticPayload);
  };

  return (
    <AISummary
      isLoading={isLoading}
      data={data}
      error={error}
      onGenerate={handleGenerate}
      onRegenerate={handleRegenerate}
      disabled={false}
    />
  );
}
